import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { Filesystem } from "@capacitor/filesystem";
import { Injectable } from "@angular/core";
import { CigarPhoto } from "../models/cigar_photo";
import { Capacitor } from "@capacitor/core";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { lastValueFrom, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { DisplayloadingService } from "./displayloading.service";

@Injectable({
  providedIn: "root",
})
export class PhotoService {
  private api = environment.apiUrl;
  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    private ls: DisplayloadingService,
  ) {}

  /**
   * @description
   * Takes photo
   * Nutzt Capacitor-Plugin um Foto aufzunehmen oder aus
   * der Galerie hinzuzufügen.
   * Schreibt für mobile App ins Dateisystem für PWA auf den Server
   * Gibt Objekt mit Pfad zum Bild zurück.
   * @param cigarName
   * @param [smokingProtokollId]
   * @returns CigarPhoto oder false
   */
  public async takePhoto(
    smokingProtokollId?: number,
  ): Promise<CigarPhoto | boolean> {
    let promptLabelHeader = this.translate.instant(
      "photoService.promptLabelHeader",
    );
    let promptLabelPhoto = this.translate.instant(
      "photoService.promptLabelPhoto",
    );
    let promptLabelCancel = this.translate.instant(
      "photoService.promptLabelCancel",
    );
    let promptLabelPicture = this.translate.instant(
      "photoService.promptLabelPicture",
    );
    const options = {
      quality: 75,
      width: 1600,
      height: 1200,
      resultType: CameraResultType.Base64,
      source: CameraSource.Prompt,
      saveToGallery: true,
      allowEditing: false,
      promptLabelHeader: promptLabelHeader,
      promptLabelPhoto: promptLabelPhoto,
      promptLabelCancel: promptLabelCancel,
      promptLabelPicture: promptLabelPicture,
    };
    try {
      const originalPhoto = await Camera.getPhoto(options);

      //Rauchprotokoll existiert schon -> ID vorhanden
      if (typeof smokingProtokollId !== "undefined") {
        const writtenPath = await this.syncSPImage(
          smokingProtokollId,
          originalPhoto,
        );
        if (typeof writtenPath === "string") {
          const photo: CigarPhoto = {
            path: writtenPath,
          };
          console.log(photo);
          return photo;
        } else {
          return false;
        }
      } else {
        //temporäres Bild
        const imageSizeMB = originalPhoto.base64String.length / 1000000;
        if (imageSizeMB > 8) {
          this.ls.presentMessage("photoService.imageTooBig", 4000, "error");
          return false;
        }
        const photo: CigarPhoto = {
          path: "data:image/jpeg;base64, " + originalPhoto.base64String,
        };
        return photo;
      }
    } catch (e) {
      return false;
    }
  }
  /**
   *
   * Params photo service
   * @param savedPath
   * @returns html-taugliche URL für Bild
   */
  getRealPhotoPath(savedPath: string) {
    return Capacitor.convertFileSrc(savedPath);
  }

  public async syncSPImage(
    imageName: number,
    tempPhoto: any = null,
    imgUrl?: string,
  ): Promise<boolean | string> {
    await this.ls.presentLoading("photoService.processing");
    //wenn Bild schon auf Server scheitert das hier...
    if (typeof imgUrl === "string") {
      try {
        tempPhoto = await Filesystem.readFile({
          path: imgUrl,
        });
      } catch (e) {
        console.log(e);
        await this.ls.hideLoading();
        return false;
      }
    }
    if (typeof tempPhoto !== "undefined" && tempPhoto !== null) {
      let imageData = tempPhoto.data;
      if (typeof imageData === "undefined") {
        imageData = tempPhoto.base64String;
        const imageSizeMB = imageData.length / 1000000;
        if (imageSizeMB > 8) {
          this.ls.presentMessage("photoService.imageTooBig", 4000, "error");
          return false;
        }
      }

      const writeImage = await this.http.post<any>(
        this.api + "/sync_sp_image.php",
        { imageData: imageData, imageName: imageName },
      );
      const imgWritten = await lastValueFrom(writeImage);
      await this.ls.hideLoading();
      //neuen Pfad zurück geben
      return imgWritten.img_path;
    } else {
      await this.ls.hideLoading();
      return false;
    }
  }

  public addHEImage(picture: CigarPhoto, entryId: number): Observable<any> {
    return this.http.post<any>(this.api + "/humidor_entry/add_picture.php", {
      picture: picture.path,
      humEntryId: entryId,
    });
  }

  public deleteHEImage(entryId: number): Observable<any> {
    return this.http.post<any>(this.api + "/humidor_entry/delete_picture.php", {
      humEntryId: entryId,
    });
  }

  public getCigarIcon(width: number, diameter: number, format: string): string {
    return `${this.api}/cigar/get_cigar_symbol.php?width=${width}&diameter=${diameter}&format=${format}`;
  }
  public getHumidorEntryImage(id: number, type: string): string {
    return `${this.api}/humidor_entry/get_picture.php?id=${id}&type=${type}`;
  }
}
